import { qltClient } from '../clients';
import type { QltSchoolSettings } from '../types';

export const SchoolSettingsRepository = {
  fetch: () => qltClient.get('/school-settings').then((res) => res.data as QltSchoolSettings),
};

export default SchoolSettingsRepository;
